<div class="overlay-inner-wrapper">
  <header class="header-2">
    <div class="branding">
      <span class="title">{{ 'Auftrag bearbeiten' | mrTranslate }}</span>
    </div>
    <div class="header-actions">
      <div class="inline-block float-right" style="padding-right: 2%; margin-top: 15px">
        @if (
          isWorkflow &&
          ((auftrag.wfStatus == 2 && isGenehmiger) ||
            (auftrag.wfStatus == 4 && isRueckmelder) ||
            auftrag.wfStatus == 3) &&
          allowEdit
        ) {
          <div class="btn-group btn-icon">
            <button class="btn btn-success" (click)="setWFAuftragStatus(1)" [disabled]="trial || wfStepCont">
              <clr-tooltip>
                <cds-icon clrTooltipTrigger shape="file" />
                <clr-tooltip-content [clrPosition]="'bottom-right'" [clrSize]="'md'">
                  {{ 'Genehmigen' | mrTranslate }}
                </clr-tooltip-content>
              </clr-tooltip>
            </button>
            @if (auftrag.wfStatus != 3) {
              <button class="btn btn-danger" [disabled]="trial || wfStepCont" (click)="setWFAuftragStatus(2)">
                <clr-tooltip>
                  <cds-icon clrTooltipTrigger shape="times" />
                  <clr-tooltip-content [clrPosition]="'bottom-right'" [clrSize]="'md'">
                    {{ 'Ablehnen' | mrTranslate }}
                  </clr-tooltip-content>
                </clr-tooltip>
              </button>
            }
            @if (auftrag.wfStatus != 4) {
              <button class="btn btn-warning" [disabled]="trial || wfStepCont" (click)="showrueckfrage = true">
                <clr-tooltip>
                  <cds-icon clrTooltipTrigger shape="wf_revert" />
                  <clr-tooltip-content [clrPosition]="'bottom-right'" [clrSize]="'md'">
                    {{ 'Rückfrage' | mrTranslate }}
                  </clr-tooltip-content>
                </clr-tooltip>
              </button>
            }
          </div>
        }

        <button
          class="btn btn-primary btn-sm"
          [disabled]="trial || (isWorkflow && auftrag.wfStatus != 4 && auftrag.wfStatus != 1) || !allowEdit"
          type="submit"
          (click)="saveAuftrag()">
          {{ 'Auftrag speichern' | mrTranslate }}
        </button>
      </div>

      <clr-dropdown>
        <button class="nav-icon" clrDropdownTrigger aria-label="toggle settings menu">
          <cds-icon shape="cog" />
        </button>
        <clr-dropdown-menu *clrIfOpen clrPosition="bottom-right">
          <button clrDropdownItem (click)="deleteAuftrag()" [disabled]="!allowEdit">
            <cds-icon style="color: currentColor" size="22" shape="times" />
            {{ 'Auftrag löschen' | mrTranslate }}
          </button>

          @if (optInterface == 3 && inforJOBNUM.length != 0) {
            <div class="dropdown-divider" role="separator"></div>
            <clr-dropdown>
              <button clrDropdownTrigger>{{ 'gehe zu HxGN EAM Auftrag' | mrTranslate }}</button>
              <clr-dropdown-menu clrPosition="bottom-left">
                @for (name of inforJOBNUM; track name) {
                  <button clrDropdownItem (click)="openEAMAuftrag(name)">
                    {{ name }}
                  </button>
                }
              </clr-dropdown-menu>
            </clr-dropdown>
            @if (!inforClosed) {
              <div class="dropdown-divider" role="separator"></div>
              <button clrDropdownItem (click)="closeEAMAuftrag()">
                {{ 'HxGN EAM Auftrag abschließen' | mrTranslate }}
              </button>
            }
          }
        </clr-dropdown-menu>
      </clr-dropdown>

      <a href="javascript:void(0);" class="nav-link nav-icon">
        <cds-icon shape="times" (click)="close()" />
      </a>
    </div>
  </header>

  <div id="auftragDetailWrapper">
    <clr-tabs>
      <clr-tab>
        <button clrTabLink (click)="tabChange()">{{ 'Auftrag' | mrTranslate }} {{ auftragId | leftPadd: 5 }}</button>
        <ng-template [(clrIfActive)]="activeTab.auftrag">
          <clr-tab-content>
            <form
              clrForm
              [formGroup]="auftragFormGroup"
              (ngSubmit)="saveAuftrag()"
              [clrLabelSize]="4"
              class="width100"
              #heightRef>
              <div class="clr-row nxm padding-10-tb">
                <div class="clr-col-lg clr-col-12">
                  @if (isWorkflow) {
                    <div class="clr-row">
                      <clr-timeline [clrLayout]="timelineLayout">
                        @for (step of wfLine; track $index) {
                          <clr-timeline-step [clrState]="step.status">
                            <clr-timeline-step-header>{{ step.time }}</clr-timeline-step-header>
                            <clr-timeline-step-title>{{ step.title }}</clr-timeline-step-title>
                            <clr-timeline-step-description>{{ step.description }}</clr-timeline-step-description>
                          </clr-timeline-step>
                        }
                      </clr-timeline>
                    </div>
                  }

                  <div class="clr-row">
                    <div class="clr-col-sm">
                      <clr-datalist-container>
                        <label class="clr-col-12 clr-col-md-4 clr-required-mark">{{ 'Titel' | mrTranslate }}</label>
                        <input
                          clrDatalistInput
                          id="titel"
                          list="titellist"
                          placeholder=""
                          name="Option"
                          type="search"
                          formControlName="titel"
                          class="clr-col-12 clr-col-md-8" />
                        <datalist id="titellist">
                          @for (c of titel; track c) {
                            <option [value]="c"></option>
                          }
                        </datalist>
                      </clr-datalist-container>
                      <clr-select-container>
                        <label class="clr-required-mark">{{ 'Firma' | mrTranslate }}</label>
                        <select clrSelect formControlName="firma">
                          <option [value]="auftragFormGroup.get('firma').value">
                            {{ auftragFormGroup.get('firma').value }}
                          </option>
                        </select>
                      </clr-select-container>
                      <clr-date-container>
                        <label class="clr-required-mark">{{ 'Termin-Start' | mrTranslate }}</label>
                        <input
                          type="date"
                          clrDate
                          name="termin"
                          [ngModel]="auftragFormGroup.get('termin').value | localeDate"
                          (ngModelChange)="auftragFormGroup.get('termin').setValue(localeDate.tosql($event))"
                          [ngModelOptions]="{ updateOn: 'blur', standalone: true }"
                          [disabled]="auftragFormGroup.disabled"
                          required />
                      </clr-date-container>
                      <clr-date-container>
                        <label class="clr-required-mark">{{ 'Termin-Ende' | mrTranslate }}</label>
                        <input
                          type="date"
                          clrDate
                          name="terminEnde"
                          [ngModel]="auftragFormGroup.get('terminEnde').value | localeDate"
                          (ngModelChange)="auftragFormGroup.get('terminEnde').setValue(localeDate.tosql($event))"
                          [ngModelOptions]="{ updateOn: 'blur', standalone: true }"
                          [disabled]="auftragFormGroup.disabled"
                          required />
                      </clr-date-container>
                      <clr-select-container>
                        <label class="clr-required-mark">{{ 'Auftragsgruppe' | mrTranslate }}</label>
                        <select clrSelect id="auftragsgruppe" formControlName="gruppenid">
                          <option [value]="getAuftragsgruppeName(auftragFormGroup.get('gruppenid').value)" selected>
                            {{ 'Auftragsgruppe auswählen' | mrTranslate }}
                          </option>
                          @for (groups of auftragsgroups; track groups.id) {
                            <option [ngValue]="+groups.id">
                              {{ groups.Bezeichnung }}
                            </option>
                          }
                        </select>
                      </clr-select-container>
                    </div>
                    <div class="clr-col-sm-1"></div>
                    <div class="clr-col-sm">
                      <clr-datalist-container>
                        <label [ngClass]="{ 'clr-required-mark': optInterface == 3 }" class="clr-col-12 clr-col-md-4">
                          {{ 'Auftragsart' | mrTranslate }}
                        </label>
                        <input
                          clrDatalistInput
                          id="auftragsart"
                          list="auftragsartlist"
                          placeholder=""
                          name="Option"
                          type="search"
                          formControlName="auftragsart"
                          class="clr-col-12 clr-col-md-8" />
                        <datalist id="auftragsartlist">
                          @for (c of auftragsarten; track c) {
                            <option [value]="c"></option>
                          }
                        </datalist>
                      </clr-datalist-container>
                      <clr-input-container>
                        <label>{{ 'Auftragsnummer' | mrTranslate }}</label>
                        <input clrInput formControlName="auftragsnummer" />
                      </clr-input-container>
                      <clr-datalist-container>
                        <label [ngClass]="{ 'clr-required-mark': optInterface == 3 }" class="clr-col-12 clr-col-md-4">
                          {{ 'Kostenart' | mrTranslate }}
                        </label>
                        <input
                          clrDatalistInput
                          id="kostenart"
                          list="kostenartlist"
                          placeholder=""
                          name="Option"
                          type="search"
                          formControlName="kostenart"
                          class="clr-col-12 clr-col-md-8" />
                        <datalist id="kostenartlist">
                          @for (c of kostenart; track c) {
                            <option [value]="c"></option>
                          }
                        </datalist>
                      </clr-datalist-container>
                      <clr-textarea-container>
                        <label>{{ 'Bemerkung' | mrTranslate }}</label>
                        <textarea clrTextarea formControlName="bemerkung" name="bemerkung" rows="3"></textarea>
                      </clr-textarea-container>
                    </div>
                    @if (optInterface == 3 && isStoerung) {
                      <div class="clr-col-sm-1"></div>
                      <div class="clr-col-sm">
                        <clr-select-container>
                          <label class="clr-required-mark clr-col-12 clr-col-md-3">{{ 'Ursache' | mrTranslate }}</label>
                          <select clrSelect formControlName="stoerursache">
                            @for (ursache of stoerursache; track ursache) {
                              <option [ngValue]="ursache">{{ ursache }}</option>
                            }
                          </select>
                        </clr-select-container>
                        <clr-select-container>
                          <label class="clr-required-mark clr-col-12 clr-col-md-3">
                            {{ 'Störgrund' | mrTranslate }}
                          </label>
                          <select clrSelect formControlName="stoergrund">
                            @for (grund of stoergrund; track grund) {
                              <option [ngValue]="grund">{{ grund | mrTranslate }}</option>
                            }
                          </select>
                        </clr-select-container>

                        <div class="clr-row">
                          <div class="clr-col-9">
                            <clr-date-container>
                              <label class="clr-col-12 clr-col-md-4">{{ 'Störbeginn' | mrTranslate }}</label>
                              <input
                                id="stoerbeginn"
                                type="date"
                                clrDate
                                [ngModel]="auftragFormGroup.get('stoerbeginn').value | localeDate"
                                (ngModelChange)="auftragFormGroup.get('stoerbeginn').setValue(localeDate.tosql($event))"
                                [ngModelOptions]="{ standalone: true, updateOn: 'blur' }" />
                            </clr-date-container>
                          </div>
                          <div class="clr-col-3 clr-align-items-start">
                            <clr-input-container style="margin-top: 20px">
                              <input
                                id="stoerbeginnzeit"
                                type="time"
                                clrInput
                                [ngModel]="auftragFormGroup.get('stoerbeginnzeit').value"
                                (ngModelChange)="auftragFormGroup.get('stoerbeginnzeit').setValue($event)"
                                [ngModelOptions]="{ standalone: true, updateOn: 'blur' }" />
                            </clr-input-container>
                          </div>
                        </div>
                        <div class="clr-row">
                          <div class="clr-col-9">
                            <clr-date-container>
                              <label class="clr-col-12 clr-col-md-4">{{ 'Störende' | mrTranslate }}</label>
                              <input
                                id="stoerende"
                                type="date"
                                clrDate
                                [ngModel]="auftragFormGroup.get('stoerende').value | localeDate"
                                (ngModelChange)="auftragFormGroup.get('stoerende').setValue(localeDate.tosql($event))"
                                [ngModelOptions]="{ standalone: true, updateOn: 'blur' }" />
                            </clr-date-container>
                          </div>
                          <div class="clr-col-3 clr-align-items-start">
                            <clr-input-container style="margin-top: 20px">
                              <input
                                id="stoerendezeit"
                                type="time"
                                clrInput
                                [ngModel]="auftragFormGroup.get('stoerendezeit').value"
                                (ngModelChange)="auftragFormGroup.get('stoerendezeit').setValue($event)"
                                [ngModelOptions]="{ standalone: true, updateOn: 'blur' }" />
                            </clr-input-container>
                          </div>
                        </div>
                        <clr-datalist-container>
                          <label class="clr-col-12 clr-col-md-3">{{ 'Festgestellt' | mrTranslate }}</label>
                          <input
                            clrDatalistInput
                            id="stoererfasser"
                            list="erfasserList"
                            placeholder=""
                            name="Option"
                            type="search"
                            formControlName="stoererfasser"
                            class="clr-col-12 clr-col-md-8" />
                          <datalist id="erfasserList">
                            @for (c of stoererfasser; track c) {
                              <option [value]="c"></option>
                            }
                          </datalist>
                        </clr-datalist-container>
                      </div>
                    }
                  </div>
                </div>
              </div>
            </form>
            <div style="min-height: 250px" [dymanicStyle]="heightRef">
              <div class="clr-row nm" style="height: 45%">
                <div class="clr-col h-100">
                  @if (objTable.rows != null) {
                    <clr-datagrid
                      #objDg
                      class="datagrid-compact auftragDetailObjectTable h-100"
                      [clrDgItemsIdentityFn]="row => row?.ostammid">
                      @for (column of objTable.columns; track column.id) {
                        <clr-dg-column [clrDgField]="column.id">
                          <ng-container
                            *clrDgHideableColumn="{
                              hidden: column.id | hideIDColumns: ['kauftsid', 'auftragid', 'bezirk', 'stellwerk'],
                            }">
                            {{ column.id | mrTranslate | titlecase }}
                          </ng-container>
                        </clr-dg-column>
                      }
                      <ng-template
                        clrVirtualScroll
                        let-row
                        [clrVirtualRowsOf]="objTable.rows"
                        [clrVirtualRowsTrackBy]="(_, row) => row?.ostammid">
                        <clr-dg-row [clrDgItem]="row">
                          @if (auftrag?.Auftragsstatus != 1) {
                            <clr-dg-action-overflow>
                              <button class="action-item" (click)="addMangel(row)">
                                {{ 'Mangel zum Objekt erfassen' | mrTranslate }}
                              </button>
                            </clr-dg-action-overflow>
                          }
                          @for (cell of objTable.columns; track cell.id) {
                            @if (cell.id != 'typ') {
                              <clr-dg-cell class="name-cell">{{ row[cell.id] | tablePrettyPrint }}</clr-dg-cell>
                            } @else {
                              <clr-dg-cell class="fill-black">
                                <cds-icon class="grid-icon" [shape]="'objekttyp' + row['typ']" size="28"></cds-icon>
                              </clr-dg-cell>
                            }
                          }
                        </clr-dg-row>
                      </ng-template>
                      <clr-dg-footer>{{ objTable.rows.length }} {{ 'Zeilen' | mrTranslate }}</clr-dg-footer>
                    </clr-datagrid>
                  }
                </div>
              </div>
              <div class="clr-row nm" style="height: 55%">
                <div class="clr-col h-100 padding-10-b">
                  @if (mangelTable?.rows?.length) {
                    <clr-datagrid
                      #mnglDg
                      [clrDgItemsIdentityFn]="row => row?.omazsid"
                      class="datagrid-compact auftragDetailMangelTable h-100"
                      id="maengelTable">
                      <clr-dg-column [style.width.px]="72">{{ 'GIS Map' | mrTranslate }}</clr-dg-column>
                      <clr-dg-column [style.width.px]="55">{{ 'Medien' | mrTranslate }}</clr-dg-column>
                      @for (column of mangelTable.columns; track column.id) {
                        <clr-dg-column>
                          <ng-container
                            *clrDgHideableColumn="{
                              hidden:
                                column.id
                                | hideIDColumns
                                  : ['kauftmid', 'auftragid', 'bezirk', 'stellwerk', 'bild', 'rueckbilder'],
                            }">
                            {{ column.id | mrTranslate | titlecase }}
                          </ng-container>
                        </clr-dg-column>
                      }
                      <ng-template
                        clrVirtualScroll
                        let-row
                        [clrVirtualRowsOf]="mangelTable.rows"
                        [clrVirtualRowsTrackBy]="(_, row) => row?.omazsid">
                        <clr-dg-row>
                          <clr-dg-action-overflow>
                            <button class="action-item" (click)="onEdit(row)">
                              {{ 'alternative Instandsetzung festlegen' | mrTranslate }}
                            </button>
                          </clr-dg-action-overflow>

                          <clr-dg-cell [style.width.px]="72">
                            @let objekt = row | get: getObjektByMangel;
                            @if (objekt | get: getGeometryType) {
                              <clr-tooltip>
                                <a href="javascript:void(0)" (click)="previewMap(row, objekt)">
                                  <cds-icon size="20" shape="search" />
                                </a>
                              </clr-tooltip>
                            } @else {
                              <cds-icon size="20" shape="search" disabled />
                            }
                          </clr-dg-cell>
                          <clr-dg-cell [style.width.px]="55">
                            <a
                              href="javascript:void(0);"
                              (click)="mangelMedia = media.parseMediaPath(row.Bild, row.rueckbilder)"
                              [class.deactivate]="!row.Bild && !row.rueckbilder">
                              <cds-icon [shape]="!row.Bild && !row.rueckbilder ? 'blank' : 'image-gallery'" />
                            </a>
                          </clr-dg-cell>
                          @for (cell of mangelTable.columns; track cell.id) {
                            <clr-dg-cell class="name-cell">{{ row[cell.id] | tablePrettyPrint }}</clr-dg-cell>
                          }
                        </clr-dg-row>
                      </ng-template>
                      <clr-dg-footer>{{ mangelTable.rows.length }} {{ 'Zeilen' | mrTranslate }}</clr-dg-footer>
                    </clr-datagrid>
                  }
                </div>
              </div>
            </div>
          </clr-tab-content>
        </ng-template>
      </clr-tab>
      <clr-tab>
        <button clrTabLink (click)="tabChange()" [disabled]="!showRueckTab || (isWorkflow && auftrag.wfStatus < 3)">
          {{ 'Rückmeldung' | mrTranslate }}
        </button>
        <clr-tab-content>
          <app-multirueckmeldungdialog
              [auftrag]="auftrag"
              [maengel]="mangelTable"></app-multirueckmeldungdialog>
        </clr-tab-content>
      </clr-tab>
      <clr-tab>
        <button clrTabLink (click)="tabChange()" [disabled]="!objTable?.rows?.length || !firmenId">
          {{ 'Abnahme nach Umbau' | mrTranslate }}
        </button>
        <ng-template [(clrIfActive)]="activeTab.abnahme">
          <clr-tab-content>
            <div class="clr-row nm">
              <div class="clr-col" style="display: flex; flex-flow: row wrap; justify-content: flex-end">
                <button type="button" class="btn btn-primary" [disabled]="trial" (click)="openAbnahmeProtokoll()">
                  {{ 'neues Protokoll erstellen' | mrTranslate }}
                </button>
              </div>
            </div>
            <!-- clr-datagrid für bestehende AbnahmeProtokolls -->
            <div class="clr-row nm padding-10-b" style="height: calc(100% - 48px)">
              <div class="clr-col h-100">
                @if (abnahmeTable.rows?.length) {
                  <clr-datagrid
                    #abnahmeDg
                    class="datagrid-compact h-100"
                    [clrDgItemsIdentityFn]="row => row?.abnahmeId">
                    @for (column of abnahmeTable.columns; track column.id) {
                      <clr-dg-column [clrDgField]="column.id">
                        <ng-container
                          *clrDgHideableColumn="{
                            hidden: column.id | hideIDColumns: ['abnahmeid', 'auftragid', 'abteilung'],
                          }">
                          {{ column.id | mrTranslate | titlecase }}
                        </ng-container>
                      </clr-dg-column>
                    }
                    <ng-template
                      clrVirtualScroll
                      let-row
                      [clrVirtualRowsOf]="abnahmeTable.rows"
                      [clrVirtualRowsTrackBy]="(_, row) => row?.abnahmeId">
                      <clr-dg-row>
                        <clr-dg-action-overflow>
                          <button class="action-item" (click)="openAbnahmeProtokoll(row)">
                            {{ 'Bearbeiten' | mrTranslate }}
                          </button>
                        </clr-dg-action-overflow>
                        @for (cell of abnahmeTable.columns; track cell.id) {
                          <clr-dg-cell class="name-cell">{{ row[cell.id] | tablePrettyPrint }}</clr-dg-cell>
                        }
                      </clr-dg-row>
                    </ng-template>
                    <clr-dg-footer>{{ abnahmeTable.rows.length }} {{ 'Zeilen' | mrTranslate }}</clr-dg-footer>
                  </clr-datagrid>
                }
              </div>
            </div>
          </clr-tab-content>
        </ng-template>
      </clr-tab>
      <clr-tab>
        <button clrTabLink (click)="tabChange()" [disabled]="isWorkflow && auftrag.wfStatus < 3">
          {{ 'Kosten' | mrTranslate }}
        </button>
        <ng-template [(clrIfActive)]="activeTab.kosten">
          <clr-tab-content>
            <app-kostenerfassung
              [kauftrid]="auftragId"
              [auftrag]="auftrag"
              [inforJobNrs]="inforJOBNUM"
              [inforClosed]="inforClosed"
              (refreshGesamtkosten)="kostenChanged = true"></app-kostenerfassung>
          </clr-tab-content>
        </ng-template>
      </clr-tab>
    </clr-tabs>
  </div>
</div>

<clr-modal [(clrModalOpen)]="showGIS" [clrModalSize]="'lg'">
  <h3 class="modal-title">{{ 'GIS Map' | mrTranslate }}</h3>
  <div class="modal-body">
    <form clrForm>
      <div style="width: 854px; height: 580px">
        <div id="previewMap" style="width: 100%; height: 100%; z-index: 2"></div>
      </div>
    </form>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-primary" (click)="showGIS = false">
      {{ 'Schließen' | mrTranslate }}
    </button>
  </div>
</clr-modal>

<clr-modal [(clrModalOpen)]="showrueckfrage">
  <h3 class="modal-title">{{ 'Rückfrage eintragen' | mrTranslate }}</h3>
  <div class="modal-body">
    <form clrForm>
      <clr-textarea-container style="margin-top: -10px">
        <textarea
          id="aa"
          class="clr-col-md-12"
          [placeholder]="'Tragen Sie hier die Rückfrage ein' | mrTranslate"
          clrTextarea
          [(ngModel)]="rueckfrage"
          name="rueckfrage"
          required
          style="width: 100%; height: 150px"></textarea>
      </clr-textarea-container>
    </form>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-primary" (click)="setWFAuftragStatus(3)">
      {{ 'Rückfrage speichern' | mrTranslate }}
    </button>
  </div>
</clr-modal>

@if (mangelMedia) {
  <app-mediaviewmodal
    (onClose)="mangelMedia = undefined"
    [srcs]="mangelMedia"
    [getMediaFromServerAll]="media.getApiFunctionMedia"
    [getBigFileFnc]="media.getApiFunctionMediaBig"
    (openPdfOverlay)="openPdf($event)"></app-mediaviewmodal>
}

<clr-modal [(clrModalOpen)]="showaltInstandsetzung" [clrModalClosable]="true" [clrModalSize]="'lg'">
  <h3 class="modal-title">{{ 'alternative Instandsetzung festlegen' | mrTranslate }}</h3>
  <div class="modal-body">
    <form clrForm [formGroup]="altMangelGroup" style="margin-top: -20px">
      <div class="clr-row">
        @if (typ_Line_Point | objtype: 'line') {
          <div class="clr-col-12" style="margin-left: -20px">
            <div class="comboboxcontainer clr-form-control">
              <label for="altvon">{{ 'von' | mrTranslate }}</label>
              <div class="clr-control-container">
                <input
                  id="altumfang"
                  class="clr-input combobox"
                  placeholder=""
                  type="number"
                  name="altvon"
                  style="width: 100px; margin-left: 120px"
                  formControlName="altvon" />
              </div>
            </div>
          </div>

          <div class="clr-col-12" style="margin-left: -20px">
            <div class="comboboxcontainer clr-form-control">
              <label for="altbis">{{ 'bis' | mrTranslate }}</label>
              <div class="clr-control-container">
                <input
                  id="altbis"
                  class="clr-input combobox"
                  placeholder=""
                  type="number"
                  name="altbis"
                  style="width: 100px; margin-left: 120px"
                  formControlName="altbis" />
              </div>
            </div>
          </div>
        }

        <div class="clr-col-12" style="margin-left: -20px">
          <div class="comboboxcontainer clr-form-control">
            <label for="altinstandsetzungshinweis">{{ 'Instandsetzunghinweis' | mrTranslate }}</label>
            <div class="clr-control-container">
              <input
                id="altinstandsetzungshinweis"
                class="clr-input combobox"
                placeholder=""
                type="search"
                name="altinstandsetzungshinweis"
                style="width: 500px; margin-left: 120px"
                formControlName="altinstandsetzungshinweis"
                list="instandsetzungList" />
            </div>
            <datalist id="instandsetzungList">
              @for (c of listih; track c.Item2) {
                <option [value]="c.Item2">{{ c.Item2 }}</option>
              }
            </datalist>
          </div>
        </div>
        <div class="clr-col-12" style="margin-left: -20px">
          <div class="comboboxcontainer clr-form-control">
            <label for="altumfang">{{ 'Umfang' | mrTranslate }}</label>
            <div class="clr-control-container">
              <input
                id="altumfang"
                class="clr-input combobox"
                placeholder=""
                type="number"
                name="altumfang"
                style="width: 100px; margin-left: 120px"
                formControlName="altumfang" />
            </div>
          </div>
        </div>
        <div class="clr-col-12" style="margin-left: -20px">
          <div class="comboboxcontainer clr-form-control">
            <label for="altmengeneinheit">{{ 'Mengeneinheit' | mrTranslate }}</label>
            <div class="clr-control-container">
              <input
                id="altmengeneinheit"
                class="clr-input combobox"
                placeholder=""
                type="search"
                name="altmengeneinheit"
                style="width: 100px; margin-left: 120px"
                formControlName="altmengeneinheit"
                list="mehList" />
            </div>
            <datalist id="mehList">
              @for (c of meh; track c) {
                <option [value]="c">{{ c }}</option>
              }
            </datalist>
          </div>
        </div>
      </div>
    </form>
    <br />
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-primary" (click)="editMangel()">{{ 'OK' | mrTranslate }}</button>
    <button type="button" class="btn" (click)="showaltInstandsetzung = false">{{ 'Beenden' | mrTranslate }}</button>
  </div>
</clr-modal>
